import AlertOctagonIcon from "@redotech/redo-icons/alert-octagon.svg";
import { DoNothingStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

export interface EndNodeData {
  step: PartialWithRequiredType<DoNothingStep>;
  deleteElements: (id: string) => void;
}

export function EndNode(data: {
  id: string;
  data: EndNodeData;
  selected?: boolean | undefined;
}) {
  return (
    <BaseNode
      icon={
        <RedoFeaturedIcon color="black" Icon={AlertOctagonIcon} size="xs" />
      }
      selected={data.selected}
      step={data.data.step}
      title="End"
    >
      <Handle id="top" position={Position.Top} type="target" />
    </BaseNode>
  );
}
